import { EmployeeDocumentsManager } from '../../../employee-documents/components/EmployeeDocumentsManager';
import type { EmployeeProfileStepProps } from './EmployeeSetupStep';

// Step 3 of the admin Employee Profile Setup: the ONE employee-scoped documents implementation (also used by Reports > Documents), with no employee picker
// here because the profile already implies the employee. The footer is drawn inside the documents card, as in Figma.
export function DocumentsStep({ employee, footer }: EmployeeProfileStepProps) {
  return <EmployeeDocumentsManager employeeId={employee.id} footer={footer} />;
}
